module.exports = __webpack_public_path__ + "static/media/4_Standing up on the inside_FR.332a3150.txt";